// Ported from qr-phone-frontend src/app/services/helper.service.ts +
// calling.service.tsx (v3.2.0.0). One shared socket for the whole app; it is
// NEVER disconnected on reject/cancel (doing so killed auto-reconnection, old #23).
import { io } from 'socket.io-client'
import { URLS } from '../config'
import { globals } from './globals'
import { getAuthEmail, getLoggedInUser } from './auth'

// RECONNECTION USES UNLIMITED ATTEMPTS WITH EXPONENTIAL BACKOFF (1s, 2s, 4s... CAPPED AT 30s)
// PLUS RANDOM JITTER, SO CLIENTS NEVER GIVE UP AND DO NOT ALL RETRY AT ONCE AFTER A SERVER RESTART.
const socketOptions = {
  path: URLS.SOCKET_PATH,
  transports: ['polling', 'websocket'],
  autoConnect: true,
  reconnection: true,
  reconnectionAttempts: Infinity,
  reconnectionDelay: 1000,
  reconnectionDelayMax: 30000,
  randomizationFactor: 0.5,
}

export const socket = io(URLS.SOCKET_URL, socketOptions)

// DEV-ONLY HOOK SO LOCAL TESTS CAN SIMULATE NETWORK DROPS (E.G. __socket.io.engine.close()).
if (import.meta.env.DEV) {
  ;(window as any).__socket = socket
}

// MAKE SURE THE SOCKET CONNECTION IS READY. IF NOT THEN ESTABLISH IT.
export const readyTheSocketConnection = async () => {
  return new Promise((resolve, reject) => {
    globals.socket = socket
    if (socket && socket.connected) {
      socketConnectionEstablished()
      return resolve(true)
    }

    const onConnect = () => {
      onSocketConnected()
      socketConnectionEstablished()
      socket.off('connect', onConnect)
      socket.off('connect_error', onConnectError)
      resolve(true)
    }

    const onConnectError = (err: any) => {
      socket.off('connect', onConnect)
      socket.off('connect_error', onConnectError)
      reject(err)
    }

    socket.on('connect', onConnect)
    socket.on('connect_error', onConnectError)

    if (!socket.connected) {
      socket.connect()
    }
  })
}

export const socketConnectionEstablished = () => {
  globals.localUser.socket_id = globals.socket.id
}

// STAFF SIDE ONLY: REGISTER THE LOGGED-IN EMAIL IN THE SOCKET SERVER. THE ANONYMOUS
// GUEST CALLER HAS NO EMAIL, SO THIS IS A NO-OP FOR THE PUBLIC FLOW.
export const onSocketConnected = async () => {
  if (socket.connected) {
    let user_email = getAuthEmail()
    if (!user_email) {
      const user = await getLoggedInUser()
      user_email = user?.email
    }
    if (user_email) {
      socket.emit('staff-join', user_email)
    }
  }
}
